import { viewAgent } from '../../services/viewAgent';
import { State } from '../../types/reducer/State';

export function setViewAgent(state: State, newAgent: any): State {
  viewAgent.set(newAgent);
  return { ...state, viewAgent: newAgent };
}
